var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"cz2__renderer__content"},[_c('camera-view',{attrs:{"controller":_vm.controller,"view":_vm.selectedView,"onlyController":_vm.onlyController,"noPoster":_vm.disablePoster}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }